import React from "react";

/**
 * @param {{
 *   id?: string,
 *   value: string,
 *   onChange: (v: string) => void,
 *   options: { value: string, label: string }[],
 *   label?: string,
 *   labelClassName?: string,
 *   className?: string,
 *   selectClassName?: string,
 * }} props
 */
export default function CreditBranchSelector({
  id = "credit-branch",
  value,
  onChange,
  options,
  label = "Branch",
  labelClassName = "text-xs font-bold uppercase tracking-wide text-slate-600",
  className = "",
  selectClassName = "mt-1 w-full max-w-xs rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-900",
}) {
  if (!options?.length) return null;
  return (
    <div className={className}>
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)} className={selectClassName}>
        {options.map((b) => (
          <option key={b.value} value={b.value}>
            {b.label}
          </option>
        ))}
      </select>
    </div>
  );
}
